import { render } from "./extension-dialog.vue?vue&type=template&id=4bde8da7&scoped=true"
import script from "./extension-dialog.vue?vue&type=script&lang=js"
export * from "./extension-dialog.vue?vue&type=script&lang=js"

import "./extension-dialog.vue?vue&type=style&index=0&id=4bde8da7&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bde8da7"]])

export default __exports__